import MatchDetailIndexContent from "@/app/(app)/preview/match-detail/page";

export default function MatchDetailIndexPage() {
  return <MatchDetailIndexContent />;
}
